<div
  class="maintenance-bar px-3 d-flex align-items-center justify-content-between text-center gap-2"
>
  <small class="text-white"> {{ message }}</small>
  <button type="button" class="icon-button maintenance-x" (click)="dismissNotification()">
    X
  </button>
</div>
